import {
  POLYOFFICE_MAX_EXPORT_FILE_COUNT,
  POLYOFFICE_MAX_EXPORT_FILE_SIZE,
  POLYOFFICE_MAX_EXPORT_SIZE,
} from './constants'

/**
 * Whether a selection cannot be exported to PolyOffice because it breaks one of
 * the size/count limits. Folders are handled separately (the export entry is
 * hidden, not disabled) since they are never exportable.
 *
 * A selection is not exportable when any of these is true:
 * - more than POLYOFFICE_MAX_EXPORT_FILE_COUNT files;
 * - cumulated size above POLYOFFICE_MAX_EXPORT_SIZE;
 * - at least one file above POLYOFFICE_MAX_EXPORT_FILE_SIZE.
 *
 * @param fileSizes sizes in bytes of every file in the selection
 */
export function isPolyOfficeExportDisabled (fileSizes: number[] = []): boolean {
  if (fileSizes.length > POLYOFFICE_MAX_EXPORT_FILE_COUNT) {
    return true
  }
  const totalSize = fileSizes.reduce((sum, size) => sum + (size || 0), 0)
  if (totalSize > POLYOFFICE_MAX_EXPORT_SIZE) {
    return true
  }
  return fileSizes.some((size) => (size || 0) > POLYOFFICE_MAX_EXPORT_FILE_SIZE)
}
